import { mapGetters } from 'vuex';
export default{
    computed: {
        ...mapGetters([
            'currencySymbol'
        ]),
    },
    methods: {
        formatNumberToCurrency(number) {
            return `${this.currencySymbol}${number.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        }
    }
}